import { Navigate } from "react-router-dom";
import { useAuth } from "../../providers/Auth/Auth";

export const RequireAuth = ({ children }: any) => {
     const { signed } = useAuth();
    if(!signed) {
        return <Navigate to="/" />
    }
    return children;
}